//export const API_URL = 'https://nardo-api-dev.plesh.co'

export const API_URL = 'https://moncler-2023-api-realdfk2ja-ew.a.run.app'